import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DepartmentRoleAccessLookupComponent } from './department-role-access-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [DepartmentRoleAccessLookupComponent],
  exports: [DepartmentRoleAccessLookupComponent]
})
export class DepartmentRoleAccessLookupModule { }
